import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "notificationactive",
  "use": "notificationactive-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"notificationactive\"><path d=\"M13.655 6.78a4.507 4.507 0 0 0-6.374 6.375c3.718 3.718 3.187 6.374 3.187 6.374l9.56-9.561s-2.655.53-6.373-3.187zM17.76 15.423a1.503 1.503 0 0 1-1.837 1.838\" stroke=\"#702F73\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path stroke=\"#702F73\" stroke-width=\"2\" stroke-linecap=\"round\" d=\"M6.398 6.249l-.18-.179\" /><circle cx=\"13\" cy=\"7\" r=\"4.5\" fill=\"#FE5F55\" stroke=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./icons/notificationactive.svg
// module id = 464
// module chunks = 0